export function pickReplicationTimestamp(metadata?: { lastReplication?: string | null; committedWatermark?: string | null; updatedAt?: string | null } | null): string | null {
  if (!metadata) return null;
  return metadata.committedWatermark || metadata.updatedAt || metadata.lastReplication || null;
}
